import React from "react";
import ButtonComponent from "../UI/ButtonComponent/ButtonComponent";
import InputComponent from "../UI/InputComponent/InputComponent";
import { Card, Row, Col } from "react-bootstrap";

const DrustvaSearch = (props) => {
  let label = "";

  switch (props.formId) {
    case "2":
      // revizorsko društvo
      label = "Unesite naziv subjekta, OIB ili registarski broj";
      break;
    case "3":
      // samostalni revizor
      label = "Unesite ime, prezime ili registarski broj";

      break;

    case "5":
      // revizorsko društvo iz druge države
      label = "Unesite naziv subjekta ili registarski broj";

      break;

    case "7":
      // REGISTAR SUBJEKATA ZA OBAVLJANJE REVIZIJE U TREĆOJ ZEMLJI I REGISTAR REVIZORA U TREĆOJ ZEMLJI
      label = "Unesite naziv / prezime subjekta, OIB ili registarski broj";
      break;

    default:
      label = props.label;
      break;
  }

  return (
    <>
      <Card className="search_card">
        <Card.Body>
          <Card.Title>Pretraga</Card.Title>
          <InputComponent
            onChange={(e) => props.onSearchChanged(e)}
            onKeyPress={(e) => props.onEnterPressed(e)}
            id="imePrezime"
            controlLabel={label}
          />

          <Row>
            <Col>
              <ButtonComponent
                onClick={props.onSearchSubmitted()}
                variant="primary"
              >
                Pretraga
              </ButtonComponent>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </>
  );
};

export default DrustvaSearch;
